export enum BuildingReviewPageAgentListTypeEnum {
  /**
   * Agent list type sale
   */
  SALE = 'sale',

  /**
   * Agent list type rent
   */
  RENT = 'rent',
}
